export const GET_ALARM_EVENTS = 'GET_ALARM_EVENTS';
export const GET_ALARM_EVENTS_FAIL = 'GET_ALARM_EVENTS_FAIL';
export const GET_ALARM_EVENTS_SUCCESS = 'GET_ALARM_EVENTS_SUCCESS';
